import React from 'react';
import { Row, Col } from '../../grid';
import { PaymentMethods } from '../../payment-methods';
import ControlGroup from '../../control-group';
import IconFeature from '../../icon-feature';
import { TYPES } from '../../payment-methods/constants';
const defaultPaymentMethods = [TYPES.visa, TYPES.mastercard, TYPES.americanExpress, TYPES.paypal];

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
const FooterPaywall = ({
  paymentsTitle,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  moneyBackTitle = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  moneyBackDescription = null,
  securityTitle,
  securityDescription,
  paymentMethods = defaultPaymentMethods,
}) => (
  <Row className="ws-ui-paywall-footer">
    {Boolean(paymentMethods.length) && (
      <Col lg={4}>
        <ControlGroup title={paymentsTitle}>
          <PaymentMethods types={paymentMethods} />
        </ControlGroup>
      </Col>
    )}
    <Col lg={8}>
      <Row>
        {moneyBackTitle && (
          <Col className="gy-4 gy-lg-0" lg={6}>
            <IconFeature
              iconGlyph="payments"
              title={moneyBackTitle}
              description={moneyBackDescription}
            />
          </Col>
        )}
        <Col className="gy-4 gy-lg-0" lg={6}>
          <IconFeature
            iconGlyph="security"
            title={securityTitle}
            description={securityDescription}
          />
        </Col>
      </Row>
    </Col>
  </Row>
);

export default FooterPaywall;
